export const isAuthenticated = () => {
    const token = localStorage.getItem('access_token');
    
    // Verifica se o token existe. Você pode adicionar mais validações se necessário.
    return token !== null;
  };
  
  // Função para realizar logout
  export const logout = () => {
    ['access_token', 'refresh_token', 'first_name', 'last_name', 'username',
      'is_staff', 'is_superuser', 'plano', 'trial_expira_em']
      .forEach((k) => localStorage.removeItem(k));
    window.location.href = '/login';
  };
  
  // Função para realizar login (Exemplo básico, pode ser ajustado conforme necessário)
  export const login = (token) => {
    localStorage.setItem('access_token', token);  // Salva o token no localStorage
  };
  